import t from "@ext/localization/locale/translate";
import { Button } from "@ui-kit/Button";
import type { ReactNode } from "react";

interface GesCloudSignInMethodFormProps {
	children: ReactNode;
	onBack: () => void;
}

export const GesCloudSignInMethodForm = ({ children, onBack }: GesCloudSignInMethodFormProps) => (
	<div className="flex flex-col gap-3">
		{children}
		<Button onClick={onBack} type="button" variant="text">
			{t("enterprise-cloud-guest.buttons.back")}
		</Button>
	</div>
);
